/**
 * model class to get data from cloud config server repository
 */
export class AppProperties {

    public uploadFileSize: number;
    public edmUploadFileSize: number;
    public logLevel: string;
    public production: string;
    public localEnviornment: string;
    public fclURL: string;
    public fclClientId: string;
    public fclSecret: string;
    public fclGrantType: string;
    public fclScope: string;
    public oktaURL: string;
    public oktaIssuer: string;
    public oktaTempIssuer: string;
    public oktaTempClientId: string;
    public oktaClientId: string;
    public oktaScopes: string[];
    public apiAddressValidationURL: string;
    public apiGatewayURL: string;
    public apiGatewayClientId: string;
    public apiGatewaySecret: string;
    public apiGatewayGrantType: string;
    public apiGatewayScope: string;
    public apiUserURL: string;
    public apiItemURL: string;
    public apiOpsItemURL: string;
    public apiASNURL: string;
    public apiGetASNURL: string;
    public apiOrderURL: string;
    public apiBulkURL: string;
    public apiLookupURL: string;
    public apiCartURL: string;
    public apiTaskGroupURL: string;
    public apiValidateItem: string;
    public apiLookupNameValueURL: string;
    public apiFacilityURL: string;
    public apiCustomerURL: string;
    public apiVendorURL: string;
    public apiLocationURL: string;
    public apiLocationSlottingUrl: string;
    public apiZoneGroupURL: string;
    public apiTaskURL: string;
    public apiCriteriaSvc: string;
    public apiPrinterUrl: string;
    public apiCycleCountDefinitionURL: string;
    public apiCycleCountURL: string;
    public apiAsnVerifyUrl: string;
    public apiAsnReceivingUrl: string;
    public apiBussServAPPID: string;
    public apiInventoryLocksURL: string;
    public apiInventoryURL: string;
    public apiValueAddedServiceURL: string;
    public apiCCApproveRejectURL: string;
    public apiWaveTaskConfigURL: string;
    public apiWaveURL: string;
    public apiWaveDetailsURL: string;
    public apiCartonURL: string;
    public apiPackServiceURL: string;
    public pattern: string;
    public superAdminRoleName: string;
    public apiRlogBussServAPPID: string;
    public apiRlogVendorURL: string;
    public apiRlogLocationCategoriesURL: string;
    public apiRlogAsnsURL: string;
    public apiRlogGroupMatrixURL: string;
    public apiRlogAsnItemsURL: string;
    public apiRlogSourceURL: string;
    public apiRlogGroupDefsURL: string;
    public apiRlogRefCodesURL: string;
    public apiRlogReturnTypesURL: string;
    public apiRlogDepartmentsURL: string;
    public apiRlogDepartmentclassesURL: string;
    public apiRlogLocationsURL: string;
    public apiRlogItemsURL: string;
    public apiRlogXRefsURL: string;
    public apiRlogPreapprovedItemsURL: string;
    public apiRlogCategoryURL: string;
    public apiRlogClusterSequenceURL: string;
    public apiRlogWarehousesURL: string;
    public apiRlogLocCapacityURL: string;
    public apiRlogSalvageDealersURL: string;
    public apiRlogCloseSBNumURL: string;
    public apiRlogCarrierURL: string;
    public apiRlogScreenConfigsURL: string;
    public apiRlogScansURL: string;
    public apiRlogRewarehousemovesURL: string;
    public apiRlogPrepSearchCriteriaURL: string;
    public apiRlogHashdefsURL: string;
    public apiRlogContainerTypesURL: string;
    public apiRlogOutboundWarehousesURL: string;
    public apiRlogPutawayURL: string;
    public apiRlogReturnPointsURL: string;
    public apiRlogRewarehouseURL: string;
    public apiRlogPrepShipmentURL: string;
    public apiRlogSlotbyURL: string;
    public apiRlogPickingURL: string;
    public apiRlogEsiURL: string;
    public apiRlogRaEntryURL: string;
    public apiRlogShipURL: string;
    public spotFileURL: string;
    public pickListReportRoute: string;
    public appPowerBIFileURL: string;
    public appPowerBIPrefixFileURL: string;    
    public apiDocumentsURL: string;
    public apiInventoryMasterURL: string;
    public apiLTLShipmentURL: string;
    public apiShipmentURL: string;
    public apiLookupsURL: string;
    public apiCutOffURL: string;
    public apiLotMasterURL: string;
    public apiOrderShipmentURL: string;
    public apiRlogReprintLabelURL: string;
    public apiRlogMobilityDekitActivityURL: string;
    public apiRlogSlpLabelModelURL: string;
    public apiRlogModifyShipmentURL: string;
    public apiRlogReturnsToteSlpLabelURL: string;
    public apiRlogSwapSerialBlURL: string;
    public apiRlogInquiryURL: string;
    public apiRlogCpiConfigURL: string;
    public apiRlogPrescanAsnsURL: string; 
    public apiRlogInvStatusChangeURL: string;   
    public apiAppointmentURL : string;
    public apiRlogRaRURL: string;  
    public uiFCLURL: string;
    public fclUserInfoClientId:string;
    public fclUserInfoSecret:string;
    public apiTaskDetailsURL: string;
    public apiReceivingUrl: string;
    public apiContainerURL: string;
    public apiSaveAuthJsonURL: string;
    public apiInvoicingURL: string;
    public apiInvoicingConfigURL: string;
    public invoiceProcess: string;
    public invoiceProcessHeader: string;
    public apiPowerBiEmbedURL: string;
    public apiPowerBiPicklistEmbedURL: string;
    public apiUfixURL: string;        
    public apiInvMovementURL: string;
	public apiUserActivityURL: string;
    public apiUserActivityTrackerURL: string;
    public apiPhysicalInventoryURL: string;
    public apiTriageURL: string;
    public apiTriageInquiryURL: string;
    public apiCartonHandler: string;
    public apiProcessURL: string;
    public apiYardURL: string;
    public apiHouseKeepingURL: string;
    public apiRepairURL: string;
    public apiInboundQaURL: string;
    public apiInboundQaAuditURL: string;
    public apiPackNewServiceUrl: string;
    public apiAQLMasterURL: string;
    public apiClearLocation : string;
    public apiBlackList : string;
    public apiGroupConfig : string;
    public apiJobSchedule: string;
    public apiBatchDummy: string;
 }
